import React from 'react';
import Panel from 'muicss/lib/react/panel';
import Button from 'muicss/lib/react/button';
import Option from 'muicss/lib/react/option';
import Select from 'muicss/lib/react/select';
import Progress from 'react-progressbar';
import {clone} from 'lodash';

export default class TestLog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {unfolded: {}};
  }

  toggleFold(id) {
    let unfolded = clone(this.state.unfolded);
    unfolded[id] = !unfolded[id];
    this.setState({unfolded});
  }

  componentWillReceiveProps(nextProps) {
    // Fold all unfolded items on `id` change
    if (nextProps.id !== this.props.id) {
      this.setState({unfolded: {}});
    }
  }

  render() {
    return <Panel>
      <div className="mui--text-title">Test log</div>

      <table className="mui-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {
            // Create a copy and reverse it (reverse mutates array)
            this.props.events ? this.props.events.slice().reverse().map(event => {
              return <tr key={event.id}>
                <td>{event.id}</td>
                <td>
                  <span className={event.final ? `final ${event.level}` : null}>
                  {
                    (event.level == "success") ?
                      <i className="material-icons success">done</i>
                    : (event.level == "error") ?
                      <i className="material-icons error">bug_report</i>
                    : null
                  } {event.html ? <span dangerouslySetInnerHTML={{__html: event.text}}></span> : event.text} {
                    event.code ? <i className="material-icons pointer" onClick={this.toggleFold.bind(this, event.id)}>{this.state.unfolded[event.id] ? 'expand_less' : 'expand_more'}</i> : null
                  }
                  </span>
                  {event.code && this.state.unfolded[event.id] ?
                    <div className={event.level == "error" ? "log-code mui--bg-accent-light" : "log-code mui--bg-primary-light"}>
                      <code><pre>{event.code}</pre></code>
                    </div> : null}
                </td>
              </tr>
            }) : null
          }
        </tbody>
      </table>
    </Panel>
  }
}



// WEBPACK FOOTER //
// ./src/components/TestLog.js